// extracted by mini-css-extract-plugin
export default {"brightnessToggle":"BrightnessToggle_brightnessToggle__gYtoD"};